import { ThemeEvents } from '@theme/events';

/** Selects the already-rendered variant media without waiting for a section request. */
function selectVariantMedia(event) {
  const variantMedia = event.detail.resource?.featured_media;
  if (!variantMedia?.id) return;

  const section = event.target.closest('.shopify-section');
  const gallery = section?.querySelector('media-gallery');
  gallery?.slideshow?.select({ id: String(variantMedia.id) }, undefined, { animate: false });
}

document.addEventListener(ThemeEvents.variantSelected, selectVariantMedia);

// Warm every small variant preview while the customer is reading the page.
// These are intentionally lightweight; full-resolution files are requested
// only for the variant the customer actually selects.
const variantPreviewUrls = new Set(
  Array.from(document.querySelectorAll('variant-picker [data-variant-media-url]'))
    .map((option) => option.dataset.variantMediaUrl)
    .filter(Boolean)
);

for (const sourceUrl of variantPreviewUrls) {
  const preload = new Image();
  preload.decoding = 'async';
  preload.fetchPriority = 'low';
  preload.src = sourceUrl;
}
